export default __webpack_public_path__ + "static/media/review-7.2662bf27.jpeg";